// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
 
import ElementUI from 'element-ui'; 
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
 
// 防止页面滚动
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);

// 富文本样式
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);
import adminApi from './util/common.js';
import  './util/localStorage.js';
 
/*引入资源请求插件*/
import VueResource from 'vue-resource'

/*使用VueResource插件*/
Vue.use(VueResource)

//定义全局变量
Vue.prototype.adminApi = adminApi; 

import axios from 'axios';

import Print from '@/plugs/print'
Vue.use(Print)

// import Lodop from '@/plugs//LodopFuncs'
// Vue.use(Lodop)


let echarts = require('echarts/lib/echarts')
// 引入图表
require('echarts/lib/chart/graph');
import { TooltipComponent } from 'echarts/components';
echarts.use([TooltipComponent]);
 
Vue.prototype.$chart = echarts
//在Vue原型上添加$bus, 并将其添加到Vue实例中
Vue.prototype.$bus=new Vue()

// 请求基准路径
// axios.defaults.baseURL = 'https://zxx.xiaocx.org/Admin';
axios.defaults.baseURL = adminApi.admin_api;

// 请求拦截（配置发送请求的信息）-------------------
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    // 请求失败的处理
    return Promise.reject(error);
});

// 响应拦截（配置请求回来的信息）-------------------
axios.interceptors.response.use(function (response) {
    if (response.data) {
        return response.data
    } else {
        return response;
    }
}, function (error) {
    // 处理响应失败
    if (error.response.data) {
        return Promise.reject(error.response.data);
    }
});
Vue.prototype.axios = axios;




// 路由守卫
// router.beforeEach((to, from, next) => {
//     if (to.path === '/Login') return next()
//     const token = sessionStorage.getItem('access-token')

//     if (!token) return next('/Login')
//     next()
// })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js